"use client"

import { useUpsertContactForm } from "@/(admin)/modules/contact-form/hooks/useUpsertContactForm"
import ContactFormUpsertForm from "@/(admin)/modules/contact-form/pages/ContactFormUpsertForm"
import Publish from "@/(admin)/modules/contact-form/pages/PublishContactForm"
import { FormSection, FormShell, FormSkeleton } from "@/(admin)/components/form"
import AccessDenied from "@/components/custom-access-denied"
import { CONTACT_FORMS } from "@/constants/admin-paths"
import { useCheckPermission } from "@/hook/use-check-permission"
import { t } from "@/languages/i18n"

const UpsertContactForm = () => {
  const { form, isEditMode, loading, submitting, domainOptions, handlers, status, setStatus } =
    useUpsertContactForm()
  const { hasPermission: checkPermission } = useCheckPermission()

  const requiredPermission = isEditMode ? "update" : "create"

  if (!checkPermission("contact-form", requiredPermission)) {
    return <AccessDenied />
  }

  if (loading && isEditMode) {
    return <FormSkeleton mainSections={2} sidebarCards={1} />
  }

  const crumbs = [
    { title: t("Contact Form"), href: `/admin${CONTACT_FORMS.LIST.PATH}` },
    { title: isEditMode ? t("Chỉnh sửa") : t("Tạo mới") },
  ]

  const main = (
    <FormSection title={t("Thông tin")} collapsible={false}>
      <ContactFormUpsertForm form={form} domainOptions={domainOptions} onFormChange={handlers.handleFormChange} />
    </FormSection>
  )

  const sidebar = (
    <Publish
      status={status}
      setStatus={setStatus}
      onSubmit={handlers.handleSubmit}
      loading={submitting}
      isEditMode={isEditMode}
    />
  )

  return (
    <FormShell
      title={isEditMode ? t("Edit Contact Form") : t("Add New Contact Form")}
      crumbs={crumbs}
      main={main}
      sidebar={sidebar}
    />
  )
}

export default UpsertContactForm
